import React from 'react';
import { Chip, Tooltip } from '@mui/material';

/** Why a flag is on for the record an edit drawer shows, and how its chip looks. */
const CHIP_PROPS_BY_SOURCE = {
	direct: { color: 'primary' },
	brokerGroup: { color: 'secondary' },
	ledger: { color: 'warning' },
	global: { variant: 'outlined' },
};

/** How a source's chip looks (colour / variant), for other chips that show it (e.g. in the feature flag picker). */
export const getFeatureFlagSourceChipProps = (source) => CHIP_PROPS_BY_SOURCE[source];

// Most relevant to the record first: on for it directly, then through a broker group, its
// ledger, then everyone
const SOURCE_ORDER = ['direct', 'brokerGroup', 'ledger', 'global'];

/**
 * Sorts [{ flag, source }] for a list of FeatureFlagChips: by how relevant the source is to
 * the record (direct, broker group, ledger, global), then by feature name.
 */
export const sortFeatureFlagChips = (chips) =>
	[...chips].sort(
		(a, b) =>
			SOURCE_ORDER.indexOf(a.source) - SOURCE_ORDER.indexOf(b.source) ||
			(a.flag.feature ?? '').localeCompare(b.flag.feature ?? ''),
	);

/**
 * One feature flag that's on for a broker group or user, as a chip with the flag's
 * description on hover. source says why it's on, and sets the colour: 'direct' (it targets
 * the record itself; pass onDelete to remove it), 'brokerGroup' (it targets one of the
 * user's broker groups), 'ledger' (it targets the record's ledger) or 'global' (on for
 * everyone). Other props go to the MUI Chip.
 */
export const FeatureFlagChip = ({ flag, source, ...chipProps }) => {
	const description =
		`${flag.description ?? ''} ${source === 'direct' ? '' : `(enabled for ${source === 'global' ? 'everyone' : source})`}`.trim();
	// An empty title shows no tooltip
	return (
		<Tooltip title={description} disableInteractive>
			<Chip
				size='small'
				label={flag.feature}
				{...CHIP_PROPS_BY_SOURCE[source]}
				{...chipProps}
			/>
		</Tooltip>
	);
};
